const state = {
    activity: null,
};

// getters
const getters = {
    activity: state => state.activity,
};

// mutations
const mutations = {
    setActivity(state, value) {
        state.activity = value;
    },
};

const actions = {
};

export default {
    state,
    getters,
    mutations,
    actions
}
